import { PublicClientApplication } from "@azure/msal-browser";  
import router from "../router"
import { JwtStorage } from "./JwtStorage"; 
import { asyncTimeout } from "./common";

let _lsAuthContainerKey = "RTBAuthContainer";
let authContainer = {
  scopes: [`api://${process.env.VUE_APP_API_ID}/access_as_user`],
  config: {
    auth: {
      clientId: process.env.VUE_APP_CLIENT_ID,
      redirectUri: process.env.VUE_APP_CLIENT_URL + "/index.html",
      authority: process.env.VUE_APP_CLIENT_AUTHORITY,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  },
  isInit: false,
  /** @type {PublicClientApplication} */
  client: {},
  /** @type { String } */
  get token() {
    return this.getAuthResultOrDefault?.token || "";
  },
  /** @type { import("@azure/msal-browser").AccountInfo } */
  account: null,
  async init() {
    let initResult = await this.client.initialize();
    this.isInit = this.client.controller.initialized; 
    return initResult;
  },
  logout: async function () {
    authContainer.account = undefined;
    localStorage.clear();
  }, 
  setAuthResult: async function (tokenResponse) {
    JwtStorage.updateKeys(tokenResponse.accessToken, "");

    let claims = JwtStorage.getClaims(); 

    let authResult = {
      token: tokenResponse.accessToken,
      refreshToken: "",
      email: tokenResponse.account.username,
      name: tokenResponse.account.name,
      role: { name: claims.find(x => x.key === "roles").value.at(0) },
      id: tokenResponse.idTokenClaims.oid
    };

    localStorage[_lsAuthContainerKey] = JSON.stringify(authResult);
  },
  /** @return {{ token: string | undefined; role: string | undefined; email: string | undefined; name: string | undefined; }} */
  get getAuthResultOrDefault() {
    return localStorage[_lsAuthContainerKey] ? JSON.parse(localStorage[_lsAuthContainerKey]) : undefined;
  },
  async login() {
    await this.init();
    await this.client.handleRedirectPromise(); 

    let tokenResponse;
    try { 
        await this.client.handleRedirectPromise();  
        tokenResponse = await this.client.acquireTokenPopup({ scopes: this.scopes, prompt: 'select_account' });
      
      let accounts = this.client.getAllAccounts(); 
      if (accounts.length !== 0) {
        this.account = accounts.at(0);
        this.client.setActiveAccount(this.account);
        await this.client.handleRedirectPromise();
      } 
    }
    catch (error) { 
      return { ok: false, response: tokenResponse, error: new Error("Unable to load token popup") };
    } 

    await asyncTimeout(100);

    await this.client.handleRedirectPromise();
    if (tokenResponse) {
      await this.setAuthResult(tokenResponse);
      let value = this.getAuthResultOrDefault;
      return { ok: true, value: value, error: undefined };
    }

    return { ok: false, value: undefined, error: 'Token response is empty' };
  },
  refresh: async function () { 
    console.log('refresh')

    await this.init(); 
    console.log('Begin refreshing token');
    var tokenResponse;
    try {
      tokenResponse = await this.client.acquireTokenSilent({ scopes: this.scopes  });
      await this.client.handleRedirectPromise();
    }
    catch {
      try {
        await this.client.handleRedirectPromise();
        tokenResponse = await this.client.acquireTokenPopup({ scopes: this.scopes, prompt: 'select_account' });
      }
      catch (err) {
        return await this.login();
      }
    }
    await asyncTimeout(100);

    if (tokenResponse) {
      await this.setAuthResult(tokenResponse)
      let value = this.getAuthResultOrDefault;
      return { ok: true, value: value, error: undefined };
    }
    return { ok: false, value: undefined, error: "Token response is empty" };
  }
};
authContainer.client = new PublicClientApplication(authContainer.config);

export default authContainer;
